<template>
  <div class="wg-row">
    <div class="com-anm22-page-title" style="font-size:24px;">
      {{ $anm22.strLang(lang, 'App settings', 'Impostazioni applicazione') }}
    </div>
    <div class="wg-row card">
      <div 
          class="wg-row title"
          @click="cards['info'] = !cards['info']">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'License info', 'Anagrafica') }}
        </div>
        <div class="edit-button">
          {{ cards['info'] ? $anm22.strLang(lang, 'Close', 'Chiudi') : $anm22.strLang(lang, 'Edit', 'Modifica') }}
        </div>
      </div>
      <div v-show="cards['info']" class="wg-row body">
        <div class="wg-row">
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, 'Name', 'Nome') }}
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <input 
                class="com-anm22-app-input-text"
                type="text"
                v-model="license.name">   
          </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <!-- Gestione metodi di pagamento -->
    <template v-if="license.config.modules.fastCash.enabled">
      <div class="wg-row card">
        <div 
            class="wg-row title"
            @click="cards['pms'] = !cards['pms']">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Payment methods', 'Metodi di pagamento') }}
          </div>
          <div class="edit-button">
            {{ cards['pms'] ? $anm22.strLang(lang, 'Close', 'Chiudi') : $anm22.strLang(lang, 'Edit', 'Modifica') }}
          </div>
        </div>
        <div v-show="cards['pms']" class="wg-row body">
          <div 
              v-for="(pm,i) in pms"
              :key="'pm-'+i"
              class="wg-row com-anm22-draggable-item"
              style="margin-bottom:10px;"
              v-anm22-drag-and-drop="{group: 'pm', start: (e) => pmDragStart(i), drop: (e) => pmDrop(i)}"
          >
            <div class="wg-col wg-xs-5 display-flex" style="align-items:center;flex-wrap:nowrap;">
              <img :src="$anm22.icons.getWorldIcon('dragHandle')" class="com-anm22-app-img-s">
              <div class="com-anm22-app-text-l">
                {{ pm.obj[lang] }}
              </div>
            </div>
            <div class="wg-col wg-xs-2 display-flex" style="align-items:center;flex-wrap:nowrap;">
              <template v-if="pm.id !== 1">
                <input 
                    :id="'check-pm-'+pm.id+'-admin'"
                    type="checkbox"
                    style="display:none;"
                    v-model="pm.admin">
                <label class="checkbox-label" :for="'check-pm-'+pm.id+'-admin'">
                  {{ pm.admin ? '✔' : '' }}
                </label>
              </template>
              <div v-else>
                {{ '✔' }}
              </div>
              <div class="horizontal-height-div" style="width:5px;"></div>
              <img :src="$anm22.icons.getWorldIcon('admin')" :title="$anm22.strLang(lang, 'Admin', 'Amministratore')" class="wg-xs-none wg-sm- com-anm22-app-img-m">
              <img :src="$anm22.icons.getWorldIcon('admin')" :title="$anm22.strLang(lang, 'Admin', 'Amministratore')" class="wg-sm-none com-anm22-app-img-s">
            </div>
            <div class="wg-col wg-xs-2 display-flex" style="align-items:center;flex-wrap:nowrap;">
              <input 
                  :id="'check-pm-'+pm.id+'-customer'"
                  type="checkbox"
                  style="display:none;"
                  v-model="pm.customer">
              <label class="checkbox-label" :for="'check-pm-'+pm.id+'-customer'">
                {{ pm.customer ? '✔' : '' }}
              </label>
              <div class="horizontal-height-div" style="width:5px;"></div>
              <img :src="$anm22.icons.getWorldIcon('userFlat')" :title="$anm22.strLang(lang, 'Customer', 'Cliente')" class="wg-xs-none wg-sm- com-anm22-app-img-m">
              <img :src="$anm22.icons.getWorldIcon('userFlat')" :title="$anm22.strLang(lang, 'Customer', 'Cliente')" class="wg-sm-none com-anm22-app-img-s">
            </div>
            <div class="wg-col wg-xs-3 display-flex" style="flex-direction:column;flex-wrap:nowrap;">
              <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'Surcharge', 'Sovrapprezzo') }}</div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row" style="align-items:center;justify-content:space-between;">
                <input 
                    type="text" 
                    class="com-anm22-app-input-text" 
                    style="display:inline-block!important;width:60%;"
                    v-model="license.paymentSurcharges[pm.id].fixed"
                >
                <div class="com-anm22-app-text.l">[&euro;]</div>
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row" style="align-items:center;justify-content:space-between;">
                <input 
                    type="text" 
                    class="com-anm22-app-input-text" 
                    style="display:inline-block!important;width:60%;"
                    v-model="license.paymentSurcharges[pm.id].percent"
                >
                <div class="com-anm22-app-text.l">[%]</div>
              </div>
            </div>
          </div>
          <div v-if="-1 !== pms.findIndex(pm => pm.id === 7)" class="wg-row" style="margin-top:10px;">
            <div class="wg-row" style="margin-bottom:10px;">
              <div class="com-anm22-app-text-xl">
                {{ $anm22.strLang(lang, 'Ask for signature when trasferring order to Spiagge.it', 'Chiedi firma per trasferire conto su Spiagge.it') }}
              </div>
            </div>
            <input 
                id="ask-for-signature"
                type="checkbox"
                style="display:none;"
                v-model="license.askYbSignature">
            <label class="checkbox-label" for="ask-for-signature">
              {{ license.askYbSignature ? '✔' : '' }}
            </label>   
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
    </template>
    <template v-if="license.config.modules.delivery.enabled">
      <div class="wg-row card">
        <div 
            class="wg-row title"
            @click="cards['ps'] = !cards['ps']">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Payment services', 'Servizi di pagamento') }}
          </div>
          <div class="edit-button">
            {{ cards['ps'] ? $anm22.strLang(lang, 'Close', 'Chiudi') : $anm22.strLang(lang, 'Edit', 'Modifica') }}
          </div>
        </div>
        <div v-show="cards['ps']" class="wg-row body">
          <!-- Paypal email -->
          <div class="wg-row" style="border:1px solid #ccc;padding:8px;">
            <img :src="$anm22.icons.getWorldIcon('paypalLogo')">
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'E-mail', 'E-mail') }}
              </div>
              <div class="horizontal-height-div" style="width:10px;"></div>
              <input 
                  class="com-anm22-app-input-text"
                  type="text"
                  v-model="license.paypalMerchantId"> 
            </div>
            <template v-if="permission === 1">
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                <!-- Paypal sandbox -->
                <div class="com-anm22-app-text-l">
                  {{ $anm22.strLang(lang, 'Sandbox', 'Sandbox') }}
                </div>
                <div class="horizontal-height-div" style="width:10px;"></div>
                <input 
                    id="check-paypal-sandbox"
                    type="checkbox"
                    style="display:none;"
                    v-model="license.paypalSandbox">
                <label class="checkbox-label" for="check-paypal-sandbox">
                  {{ license.paypalSandbox ? '✔' : '' }}
                </label>
              </div>
            </template>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <!-- Stripe -->
          <div class="wg-row" style="border:1px solid #ccc;padding:8px;">
            <img style="height:32px;" :src="$anm22.icons.getWorldIcon('stripeLogo')">
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <div class="com-anm22-app-text-l">
                Test Mode
              </div>
              <div class="horizontal-height-div" style="width:10px;"></div>
              <input 
                  id="check-stripe-test"
                  type="checkbox"
                  style="display:none;"
                  v-model="license.stripeTest">
              <label class="checkbox-label" for="check-stripe-test">
                {{ license.stripeTest ? '✔' : '' }}
              </label>
              <div class="horizontal-height-div" style="width:10px;"></div>
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Selecting this option will result in using a test account for transactions', 'Selezionare questa opzione risulterà nell\'uso dell\'account di test per le transazioni') }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <template v-if="!license.stripeAccount">
              <img :src="$anm22.icons.getWorldIcon('stripeConnectButton')" style="cursor:pointer;" @click="connectWithStripe">
            </template>
            <template v-else>
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Stripe account successfully connected', 'Account Stripe collegato con successo') }}
              </div>
              <template v-if="permission === 1">
                <div class="vertical-height-div" style="height:10px;"></div>
                <div class="com-anm22-app-text-l">
                  {{ 'Stripe Account: ' + license.stripeAccount }}
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
    </template>
    <template  v-if="license.config.modules.fastCash.enabled">
      <!-- Gestione dei metodi di consegna -->
      <div class="wg-row card">
        <div 
            class="wg-row title"
            @click="cards['dts'] = !cards['dts']">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Delivery methods', 'Metodi di consegna') }}
          </div>
          <div class="edit-button">
            {{ cards['dts'] ? $anm22.strLang(lang, 'Close', 'Chiudi') : $anm22.strLang(lang, 'Edit', 'Modifica') }}
          </div>
        </div>
        <div v-show="cards['dts']" class="wg-row body">
          <div 
              v-for="(dt,i) in dts"
              :key="'dt-'+i"
              class="wg-row com-anm22-draggable-item"
              style="margin-bottom:10px;"
              v-anm22-drag-and-drop="{group: 'dt', start: (e) => dtDragStart(i), drop: (e) => dtDrop(i)}"
          >
            <div class="wg-col wg-xs-5 display-flex" style="align-items:center;flex-wrap:nowrap;">
              <img :src="$anm22.icons.getWorldIcon('dragHandle')" class="com-anm22-app-img-s">
              <div class="com-anm22-app-text-l">
                {{ dt.obj[lang] }}
              </div>
            </div>
            <div class="wg-col wg-xs-2 display-flex" style="align-items:center;flex-wrap:nowrap;">
              <template v-if="dt.id !== 4">
                <input 
                    :id="'check-dt-'+dt.id+'-admin'"
                    type="checkbox"
                    style="display:none;"
                    v-model="dt.admin">
                <label class="checkbox-label" :for="'check-dt-'+dt.id+'-admin'">
                  {{ dt.admin ? '✔' : '' }}
                </label>
              </template>
              <div v-else>
                {{ '✔' }}
              </div>
              <div class="horizontal-height-div" style="width:5px;"></div>
              <img :src="$anm22.icons.getWorldIcon('admin')" :title="$anm22.strLang(lang, 'Admin', 'Amministratore')" class="wg-xs-none wg-sm- com-anm22-app-img-m">
              <img :src="$anm22.icons.getWorldIcon('admin')" :title="$anm22.strLang(lang, 'Admin', 'Amministratore')" class="wg-sm-none com-anm22-app-img-s">
            </div>
            <div class="wg-col wg-xs-2 display-flex" style="align-items:center;flex-wrap:nowrap;">
              <input 
                  :id="'check-dt-'+dt.id+'-customer'"
                  type="checkbox"
                  style="display:none;"
                  v-model="dt.customer">
              <label class="checkbox-label" :for="'check-dt-'+dt.id+'-customer'">
                {{ dt.customer ? '✔' : '' }}
              </label>
              <div class="horizontal-height-div" style="width:5px;"></div>
              <img :src="$anm22.icons.getWorldIcon('userFlat')" :title="$anm22.strLang(lang, 'Customer', 'Cliente')" class="wg-xs-none wg-sm- com-anm22-app-img-m">
              <img :src="$anm22.icons.getWorldIcon('userFlat')" :title="$anm22.strLang(lang, 'Customer', 'Cliente')" class="wg-sm-none com-anm22-app-img-s">
            </div>
            <div class="wg-col wg-xs-3 display-flex" style="flex-direction:column;flex-wrap:nowrap;">
              <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'Delivery', 'Consegna') }}</div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row" style="align-items:center;justify-content:space-between;">
                <input 
                    type="text" 
                    class="com-anm22-app-input-text" 
                    style="display:inline-block!important;width:60%;"
                    v-model.number="license.deliveryPrices[dt.id]"
                >
                <div class="com-anm22-app-text.l">[&euro;]</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
    </template>
    <template v-if="license.config.modules.delivery.enabled">
      <div class="wg-row card">
        <div 
            class="wg-row title"
            @click="cards['dopts'] = !cards['dopts']">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Delivery options', 'Opzioni di consegna') }}
          </div>
          <div class="edit-button">
            {{ cards['dopts'] ? $anm22.strLang(lang, 'Close', 'Chiudi') : $anm22.strLang(lang, 'Edit', 'Modifica') }}
          </div>
        </div>
        <div v-show="cards['dopts']" class="wg-row body">
          <!-- Gestione stampa sequenze manuale -->
          <template v-if="license.config.modules.sequences.enabled">
            <div class="wg-row">
              <div class="com-anm22-app-text-xl">
                {{ $anm22.strLang(lang, 'Manual management of orders print', 'Gestione manuale stampa sequenze') }}
              </div>
              <div class="vertical-height-div" style="height:10px;"></div>
              <input 
                  id="manual-print-sequences"
                  type="checkbox"
                  style="display:none;"
                  v-model="license.printSequences">
              <label class="checkbox-label" for="manual-print-sequences">
                {{ license.printSequences ? '✔' : '' }}
              </label>   
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
          </template>
          <!-- Delivery VAT -->
          <div class="wg-row">
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, 'Delivery cost VAT', 'IVA costo di consegna') + ' [%]' }}
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <input 
                type="number"
                v-model.number="license.deliveryVat">
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <!-- Minimum order for delivery -->
          <div class="wg-row">
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, 'Minimum order for delivery', 'Ordine minimo per la consegna') }} [&euro;]
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <input 
                class="com-anm22-app-input-text"
                type="text"
                v-model="license.minToDelivery">   
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <!-- Delivery options -->
          <div class="wg-row">
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, 'Delivery settings', 'Opzioni per la consegna') }}
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <select class="com-anm22-app-select" v-model="license.deliveryOption">
              <option 
                  v-for="(obj, key, index) in $anm22.tableClasses.foodDeliveryOption().getAll()"
                  :key="'delivery-opt-'+index"
                  :value="key">
                {{ obj[lang] }}
              </option>
            </select>    
          </div>
          <template v-if="license.config.modules.delivery.enabled">
            <div class="vertical-height-div" style="height:10px;"></div>
            <!-- Min offset for delivery -->
            <div class="wg-row">
              <div class="com-anm22-app-text-xl">
                {{ $anm22.strLang(lang, 'Minimum waiting time for home delivery', 'Tempo di attesa minimo per la consegna a domicilio')
                    + ' [min]' }}
              </div>
              <div class="vertical-height-div" style="height:10px;"></div>
              <input 
                  type="number"
                  v-model.number="license.deliveryMinutesThreshold">
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <!-- Pickup points -->
            <div class="wg-row">
              <div class="com-anm22-app-text-xl">
                {{ $anm22.strLang(lang, 'Delivery pickup points', 'Punti di ritiro') }}
              </div>
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row">
                <input 
                    type="text"
                    style="width:150px;margin-right:10px;"
                    :placeholder="$anm22.strLang(lang, 'Italian', 'Italiano')"
                    v-model="newPickupPoint.it">
                <input 
                    type="text"
                    style="width:150px;margin-right:10px;"
                    :placeholder="$anm22.strLang(lang, 'English', 'Inglese')"
                    v-model="newPickupPoint.en">
                <button class="small" @click="addPickupPoint">
                  <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Add', 'Aggiungi') }}</div>
                </button>
              </div>
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row">
                <div 
                    v-for="(point, i) in license.deliveryPickUpPoints"
                    :key="'pup-'+i"
                    class="pickup-point-label"
                    @click="license.deliveryPickUpPoints.splice(i, 1)"
                >
                  {{ '[' + point.it + ', ' + point.en + ']' }}
                  <img 
                      class="com-anm22-app-img-fixed-height-s"
                      :src="$anm22.icons.getWorldIcon('deleteBin')"
                      style="cursor:pointer;margin-left:2px;">
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
    </template>
    <template v-if="license.config.modules.fiscal.enabled">
      <!-- Tipi di ricevuta -->
      <div class="wg-row card">
        <div 
            class="wg-row title"
            @click="cards['rts'] = !cards['rts']">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Fiscal receipt types', 'Tipologie documento fiscale') }}
          </div>
          <div class="edit-button">
            {{ cards['rts'] ? $anm22.strLang(lang, 'Close', 'Chiudi') : $anm22.strLang(lang, 'Edit', 'Modifica') }}
          </div>
        </div>
        <div v-show="cards['rts']" class="wg-row body">
          <div 
              v-for="(rt,i) in rts"
              :key="'rt-'+i"
              class="wg-row com-anm22-draggable-item"
              style="margin-bottom:10px;"
              v-anm22-drag-and-drop="{group: 'rt', start: (e) => rtDragStart(i), drop: (e) => rtDrop(i)}"
          >
            <div class="wg-col wg-xs-5 display-flex" style="align-items:center;flex-wrap:nowrap;">
              <img :src="$anm22.icons.getWorldIcon('dragHandle')" class="com-anm22-app-img-s">
              <div class="com-anm22-app-text-l">
                {{ rt.obj[lang] }}
              </div>
            </div>
            <div class="wg-col wg-xs-2 display-flex" style="align-items:center;flex-wrap:nowrap;">
              <input 
                  :id="'check-rt-'+rt.id"
                  type="checkbox"
                  style="display:none;"
                  v-model="rt.customer">
              <label class="checkbox-label" :for="'check-rt-'+rt.id">
                {{ rt.customer ? '✔' : '' }}
              </label>
              <div class="horizontal-height-div" style="width:5px;"></div>
              <img :src="$anm22.icons.getWorldIcon('userFlat')" :title="$anm22.strLang(lang, 'Customer', 'Cliente')" class="wg-xs-none wg-sm- com-anm22-app-img-m">
              <img :src="$anm22.icons.getWorldIcon('userFlat')" :title="$anm22.strLang(lang, 'Customer', 'Cliente')" class="wg-sm-none com-anm22-app-img-s">
            </div>
          </div>
          <template v-if="license.config.modules.invoices.enabled">
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, 'Invoice document type', 'Tipologia fattura') }}
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <select class="com-anm22-app-select" v-model="license.documentSeries">
              <option 
                  v-for="(doc, index) in documentSeries"
                  :key="'document-series-'+index"
                  :value="doc.idWorldDocumentSeries">
                {{ doc.name }}
              </option>
            </select>  
          </template>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
    </template>
    <!-- Opening hours -->
    <div class="wg-row card">
      <div class="wg-row title" @click="cards['ohs'] = !cards['ohs']">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'Opening hours', 'Orari di apertura') }}
        </div>
        <div class="edit-button">
          {{ cards['ohs'] ? $anm22.strLang(lang, 'Close', 'Chiudi') : $anm22.strLang(lang, 'Edit', 'Modifica') }}
        </div>
      </div>
      <div v-show="cards['ohs']" class="wg-row body">
        <div
            v-for="(oh,i) in ohs"
            :key="'oh-'+i"
            class="wg-row" style="align-items:center;">
          <div class="wg-col wg-xs-12 wg-lg-3 com-anm22-app-text-l" style="padding:10px 10px 0 0;">
            {{ $anm22.tableClasses.worldWeekDay().getById(i+1)[lang] }}
          </div>
          <div 
              v-for="(period,j) in oh"
              :key="'period-'+i+'-'+j"
              class="wg-col wg-xs-12 wg-md-4 wg-lg-3" 
              style="padding:10px 10px 0 0;"
          >
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <input 
                  class="input-lunch"
                  style="width:110px;"
                  type="time" 
                  :value="period ? period['from'].format('HH:mm') : ''"
                  @change="changeOh(i, j, 'from', $event.target.value)">
              <div class="com-anm22-app-text-l" style="padding:0 5px;">-</div>
              <input 
                  class="input-lunch"
                  style="width:110px;" 
                  type="time" 
                  :value="period ? period['to'].format('HH:mm') : ''"
                  @change="changeOh(i, j, 'to', $event.target.value)">
            </div>
          </div>
        </div>
        <div class="wg-row" style="margin-top:20px; border-top: 1px solid #ccc; padding: 16px 0;">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Seasonal closure', 'Chiusura stagionale') }}
          </div>
          <div class="horizontal-height-div" style="width:10px;"></div>
          <input 
              id="check-seasonal-closure"
              type="checkbox"
              style="display:none;"
              v-model="license.seasonalClosure">
          <label class="checkbox-label" for="check-seasonal-closure">
            {{ license.seasonalClosure ? '✔' : '' }}
          </label>   
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <template v-if="license.config.modules.tables.enabled">
      <!-- Coperti -->
      <div class="wg-row card">
        <div class="wg-row title" @click="cards['covers'] = !cards['covers']">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Cover', 'Coperto') }}
          </div>
          <div class="edit-button">
            {{ cards['covers'] ? $anm22.strLang(lang, 'Close', 'Chiudi') : $anm22.strLang(lang, 'Edit', 'Modifica') }}
          </div>
        </div>
        <div v-show="cards['covers']" class="wg-row body">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;margin-bottom:10px;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Lunch', 'Pranzo') + ' [&euro;]'}}
              </div>
              <input 
                  type="number"
                  style="margin-left:auto;width:110px;text-align:right;"
                  v-model.number="lunchCover">
            </div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;margin-bottom:10px;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Dinner', 'Cena') + ' [&euro;]' }}
              </div>
              <input 
                  type="number"
                  style="margin-left:auto;width:110px;text-align:right;"
                  v-model.number="dinnerCover">
            </div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;margin-bottom:10px;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Time switch', 'Ora cambio') }}
              </div>
              <input 
                  type="time"
                  style="margin-left:auto;width:110px;text-align:right;"
                  v-model.lazy="coverSwitch">
            </div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Cover VAT', 'IVA coperto') + ' [%]'}}
              </div>
              <input 
                  type="number"
                  style="margin-left:auto;width:110px;text-align:right;"
                  v-model.number="license.coverVat">
            </div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
    </template>
    <template v-if="license.config.modules.delivery.enabled">
      <!-- Shifts -->
      <div class="wg-row card">
        <div 
            class="wg-row title"
            @click="cards['shifts'] = !cards['shifts']">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Order limits', 'Gestione limitazione ordini') }}
          </div>
          <div class="edit-button">
            {{ cards['shifts'] ? $anm22.strLang(lang, 'Close', 'Chiudi') : $anm22.strLang(lang, 'Edit', 'Modifica') }}
          </div>
        </div>
        <div v-show="cards['shifts']" class="wg-row body">
          <div
            v-for="(weekDay) in [0,1,2,3,4,5,6]"
            :key="'shifts-weekDay-'+weekDay"
            class="wg-row" style="align-items:center;">
            <div class="wg-row">
              <div class="com-anm22-app-text-l">
                {{ $anm22.tableClasses.worldWeekDay().getById(weekDay+1)[lang] }}
              </div>
            </div>
            <div 
                v-for="(shift, j) in license.shifts[weekDay]"
                :key="'shift-'+weekDay+'-'+j"
                class="wg-row"
                style="align-items:center;"
            >
              <div class="wg-col wg-xs-12 wg-sm-2" style="padding:10px 10px 0 0;">
                <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                  <img 
                      class="com-anm22-app-img-fixed-height-s" 
                      style="cursor:pointer;margin-right:5px;" 
                      :src="$anm22.icons.getWorldIcon('deleteBlack')" 
                      @click="removeShift(weekDay, j)">
                  <div class="com-anm22-app-text-l">
                    {{ $anm22.strLang(lang, 'Shift ', 'Turno ') + (j + 1) }}
                  </div>
                </div>
              </div>
              <div class="wg-col wg-xs-12 wg-sm-4" style="padding:10px 10px 0 0;">
                <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                  <div class="display-flex" style="flex-direction:column;margin-right:5px;">
                    <div class="com-anm22-app-text-m">
                      {{ $anm22.strLang(lang, 'From', 'Da') }}
                    </div>
                    <div class="vertical-height-div" style="height:2px;"></div>
                    <input 
                        style="width:110px;"
                        type="time" 
                        v-model="shift.from">
                  </div>
                  <div class="display-flex" style="flex-direction:column;">
                    <div class="com-anm22-app-text-m">
                      {{ $anm22.strLang(lang, 'To', 'A') }}
                    </div>
                    <div class="vertical-height-div" style="height:2px;"></div>
                    <input 
                        style="width:110px;" 
                        type="time" 
                        v-model="shift.to">
                  </div>
                </div>
              </div>
              <div class="wg-col wg-xs-12 wg-sm-6" style="padding:10px 10px 0 0;">
                <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                  <div class="display-flex" style="flex-direction:column;margin-right:5px;">
                    <div class="com-anm22-app-text-m">
                      {{ $anm22.strLang(lang, 'Orders limit', 'Limite ordini') }}
                    </div>
                    <div class="vertical-height-div" style="height:2px;"></div>
                    <input 
                        style="width:110px;"
                        type="number" 
                        v-model="shift.limit_orders">
                  </div>
                  <div class="display-flex" style="flex-direction:column;margin-right:5px;">
                    <div class="com-anm22-app-text-m">
                      {{ $anm22.strLang(lang, 'Products limit', 'Limite prodotti') }}
                    </div>
                    <div class="vertical-height-div" style="height:2px;"></div>
                    <input 
                        style="width:110px;"
                        type="number" 
                        v-model="shift.limit_products">
                  </div>
                  <div class="display-flex" style="flex-direction:column;">
                    <div class="com-anm22-app-text-m">
                      {{ $anm22.strLang(lang, 'Interval', 'Intervallo') + ' [min]' }}
                    </div>
                    <div class="vertical-height-div" style="height:2px;"></div>
                    <select style="width:110px;" class="com-anm22-app-select" v-model="shift.interval">
                      <option 
                          v-for="(interval) in [15,30,45,60]"
                          :key="'interval-'+interval"
                          :value="interval">
                        {{ interval }}
                      </option>
                    </select>    
                  </div>
                </div>
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <button class="small" @click="addNewShift(weekDay)">
              {{ $anm22.strLang(lang, 'Add', 'Aggiungi') }}
            </button>
            <div class="vertical-height-div" style="height:10px;"></div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
    </template>
    <!-- GUI -->
    <div class="wg-row card">
      <div 
          class="wg-row title"
          @click="cards['gui'] = !cards['gui']">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'Graphical options', 'Opzioni grafiche') }}
        </div>
        <div class="edit-button">
          {{ cards['gui'] ? $anm22.strLang(lang, 'Close', 'Chiudi') : $anm22.strLang(lang, 'Edit', 'Modifica') }}
        </div>
      </div>
      <div v-show="cards['gui']" class="wg-row body">
        <!-- Order products by name -->
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Order products alphabetically', 'Ordina prodotti alfabeticamente') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <input 
              id="check-prod-order"
              type="checkbox"
              style="display:none;"
              v-model="license.orderByName">
          <label class="checkbox-label" for="check-prod-order">
            {{ license.orderByName ? '✔' : '' }}
          </label>   
        </div>
        <template  v-if="license.config.modules.fastCash.enabled">
          <div class="vertical-height-div" style="height:10px;"></div>
          <!-- fastCash multi view -->
          <div class="wg-row">
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, 'Show multiple view in fastCash', 'Mostra viste multiple in cassa rapida') }}
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <input 
                id="check-fastcashMultiview"
                type="checkbox"
                style="display:none;"
                v-model="license.fastcashMultiview">
            <label class="checkbox-label" for="check-fastcashMultiview">
              {{ license.fastcashMultiview ? '✔' : '' }}
            </label>   
          </div>
        </template>
        <!-- place order multi view -->
        <template v-if="license.config.modules.delivery.enabled">
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, 'Show multiple view in customer ordering page', 'Mostra viste multiple nella pagina di ordinazione cliente') }}
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <input 
                id="check-placeOrderMultiView"
                type="checkbox"
                style="display:none;"
                v-model="license.placeOrderMultiview">
            <label class="checkbox-label" for="check-placeOrderMultiView">
              {{ license.placeOrderMultiview ? '✔' : '' }}
            </label>   
          </div>
        </template>
        <!-- grafica pagina take order -->
        <template v-if="license.config.modules.tables.enabled">
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, 'Take order view', 'Grafica ordinazione da palmare') }}
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <select class="com-anm22-app-select" v-model="license.employeeOrderView">
              <option :value="0">
                {{ $anm22.strLang(lang, 'Double screen with cart', 'Doppia schermata con carrello') }}
              </option>
              <option :value="1">
                {{ $anm22.strLang(lang, 'Single screen', 'Schermata unica') }}
              </option>
            </select>    
          </div>
        </template>
      </div>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <template v-if="license.config.modules.delivery.enabled">
      <!-- Miscellaneous -->
      <div class="wg-row card">
        <div 
            class="wg-row title"
            @click="cards['misc'] = !cards['misc']">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Miscellaneous', 'Varie') }}
          </div>
          <div class="edit-button">
            {{ cards['misc'] ? $anm22.strLang(lang, 'Close', 'Chiudi') : $anm22.strLang(lang, 'Edit', 'Modifica') }}
          </div>
        </div>
        <div v-show="cards['misc']" class="wg-row body">
          <!-- TripAdvisor -->
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'TripAdvisor ID', 'ID TripAdvisor') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <input 
              class="com-anm22-app-input-text"
              type="text"
              v-model="license.tripAdvisorId">
          <div class="vertical-height-div" style="height:10px;"></div>
          <!-- Regolamento -->
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Terms of agreement', 'Regolamento') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
            <input 
                id="terms-type-text"
                type="radio"
                style="display:none;"
                :value="1"
                v-model="license.termsType">
            <label class="radio-label" for="terms-type-text">{{ license.termsType === 1 ? '✔' : '' }}</label>
            <div class="com-anm22-app-text-l" style="margin-left:5px;">{{ $anm22.strLang(lang, 'Text', 'Testo') }}</div>
            <div class="horizontal-height-div" style="width:10px;"></div>
            <input 
                id="terms-type-url"
                type="radio"
                style="display:none;"
                :value="2"
                v-model="license.termsType">
            <label class="radio-label" for="terms-type-url">{{ license.termsType === 2 ? '✔' : '' }}</label>
            <div class="com-anm22-app-text-l" style="margin-left:5px;">{{ 'URL' }}</div>
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <input v-if="license.termsType === 2" type="text" v-model="license.termsUrl">
            <textarea v-else v-model="license.termsText"></textarea>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, 'Automatically accept orders from customers', 'Accettare automaticamente ordini da clienti') }}
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <input 
                id="automatically-accept"
                type="checkbox"
                style="display:none;"
                v-model="license.acceptAutomatically">
            <label class="checkbox-label" for="automatically-accept">
              {{ license.acceptAutomatically ? '✔' : '' }}
            </label>   
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, 'Play alarm when new order from customer', 'Suonare allarme alla ricezione di un nuovo ordine da cliente') }}
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <input 
                id="order-alarm"
                type="checkbox"
                style="display:none;"
                v-model="license.orderAlarm">
            <label class="checkbox-label" for="order-alarm">
              {{ license.orderAlarm ? '✔' : '' }}
            </label>   
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
    </template>
    <div class="wg-row">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Save', 'Salva')" 
          @click="save">
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from 'vuex';
import { Anm22DragAndDrop } from '../../../../../world/spa/directives/Anm22DragAndDrop';
import uuid from 'uuid/v4';

export default {
  props: {
    licenseRef: Object,
    timezone: String,
  },
  data() {
    return {
      license: {...this.licenseRef},
      dragging: null,
      // stripeConnectTest: false,
      cards: {
        info: false,
        pms: false,
        dts: false,
        rts: false,
        ohs: false,
        covers: false,
        ps: false,
        dopts: false,
        shifts: false,
        gui: false,
        misc: false,
      },
      newPickupPoint: {
        it: '',
        en: ''
      }
    }
  },
  directives: {
    Anm22DragAndDrop
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    employment() {
      return this.$store.getters["foodEmployments/get"](
        this.license.id + "-" + this.user.idWorldUser
      );
    },
    permission() {
      return this.employment ? this.employment.permission : 6;
    },
    hasYbLicenses() {
      return !!this.$store.getters['ybLicenses/getByLicense'](this.license.id).length;
    },
    pms() {
      return this.license.paymentMethods
        .filter(pm => {
          if(pm.id == 7) {
            return this.hasYbLicenses;
          }
          return true;
        });
    },
    dts() {
      return this.license.deliveryTypes
        .filter(dt => {
          // Delivery module
          if(dt.id == 1 || dt.id == 2 || dt.id == 7 || dt.id == 9 || dt.id == 10 || dt.id == 11) {
            return this.license.config.modules.delivery.enabled;
          }
          // Tables module
          if(dt.id == 5) {
            return this.license.config.modules.tables.enabled;
          }
          return true;
        });
    },
    rts() {
      return this.license.customerReceiptTypes
        .filter(rt => {
          if(rt.id === 2) {
            return this.license.config.modules.invoices.enabled;
          }
          return true;
        });
    },
    ohs() {
      return this.license.openingHours
        .map(day => {
          let day_periods = [];
          [0,1,2].forEach(i => {
            if(day[i]) {
              day_periods.push({
                from: this.$moment.tz( day[i]['from'], 'HH:mm', this.timezone),
                to: this.$moment.tz(day[i]['to'], 'HH:mm', this.timezone)
              });
            } else {
              day_periods.push(null);
            }
          });
          return day_periods;
        });
    },
    lunchCover: {
      get() {
        return this.license.lunchCover.toFixed(2);
      },
      set(value) {
        this.license.lunchCover = value;
      }
    },
    dinnerCover: {
      get() {
        return this.license.dinnerCover.toFixed(2);
      },
      set(value) {
        this.license.dinnerCover = value;
      }
    },
    coverSwitch: {
      get() {
        return this.$moment.tz(this.license.coverSwitch || '00:00', 'HH:mm', this.timezone).format('HH:mm');
      },
      set: _.debounce(function(newTime){
        this.license.coverSwitch =  this.$moment.tz(newTime, 'HH:mm', this.timezone).format('HH:mm');
      }, 1000)
    },
    documentSeries() {
      return this.$store.getters['documentSeries/getByWork'](this.license.work);
    }
  },
  methods: {
    pmDragStart(i) {
      this.dragging = i;
    },
    pmDrop(i) {
      const temp = this.license.paymentMethods[i];
      this.license.paymentMethods.splice(i, 1, this.license.paymentMethods[this.dragging]);
      this.license.paymentMethods.splice(this.dragging, 1, temp);
      this.dragging = null;
    },
    dtDragStart(i) {
      this.dragging = i;
    },
    dtDrop(i) {
      const temp = this.license.deliveryTypes[i];
      this.license.deliveryTypes.splice(i, 1, this.license.deliveryTypes[this.dragging]);
      this.license.deliveryTypes.splice(this.dragging, 1, temp);
      this.dragging = null;
    },
    rtDragStart(i) {
      this.dragging = i;
    },
    rtDrop(i) {
      const temp = this.license.customerReceiptTypes[i];
      this.license.customerReceiptTypes.splice(i, 1, this.license.customerReceiptTypes[this.dragging]);
      this.license.customerReceiptTypes.splice(this.dragging, 1, temp);
      this.dragging = null;
    },
    changeOh: _.debounce(function(dayOfWeek, period, fromOrTo, value) {
      // valore cancellato
      if(!value) {
        this.license.openingHours[dayOfWeek].splice(period, 1);
        return;
      } else {
        if(!this.license.openingHours[dayOfWeek][period]) {
          this.$set(this.license.openingHours[dayOfWeek], period, {from: "00:00", to: "00:00"});
        }
        this.$set(this.license.openingHours[dayOfWeek][period], fromOrTo, value);
      }
    }, 1000),
    addNewShift(weekDay) {
      const shift = {
        from: '00:00',
        to: '00:30',
        limit_orders: 0,
        limit_products: 0,
        interval: 30
      };
      // get last of day if present
      if(this.license.shifts[weekDay]) {
        const last = {...this.license.shifts[weekDay][this.license.shifts[weekDay].length - 1]};
        shift.from = last.to;
        shift.to = this.$moment.tz(last.to, 'HH:mm', this.timezone).add(last.interval, 'minutes').format('HH:mm');
        shift.interval = last.interval; 
      } else {
        this.$set(this.license.shifts, weekDay, []);
      }
      this.license.shifts[weekDay].push(shift);
    },
    removeShift(weekDay, index) {
      this.license.shifts[weekDay].splice(index, 1);
    },
    async connectWithStripe() {
      let connectUrl = 'https://connect.stripe.com/oauth/authorize?';
      // Il client ID è quello Live in produzione e quello Test in locale
      connectUrl += 'client_id=' + process.env.VUE_APP_STRIPE_CONNECT_CLIENT_ID;
      // state nonce
      const state = uuid();
      connectUrl += '&state=' + state;
      // scope
      connectUrl += '&scope=read_write';
      // response type
      connectUrl += '&response_type=code';
      // return uri
      connectUrl += '&redirect_uri=' + encodeURIComponent(process.env.VUE_APP_STRIPE_CONNECT_REDIRECT_URI);
      // stripe_user data to precompile information in stripe form
      try{ 
        const response = await this.$http.post('settings/init-stripe-connect', {
          state
        });
        if(response.data.success) {
          // redirect
          location.href = connectUrl;
        }
      } catch(e) {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Cannot perform this operation when offline",
            "Non è possibile effettuare l'operazione in modalità offline"
          ),
          type: "alarm"
        });
      }
    },
    addPickupPoint() {
      this.license.deliveryPickUpPoints.push(this.newPickupPoint);
      this.newPickupPoint = {
        it: '',
        en: ''
      };
    },
    save() {
      this.$http
        .post('settings/license', {
          license: this.license
        })
        .then(response => {
          this.$store.dispatch('foodLicenses/update', {
            vlf: this.$vlf('foodLicenses'), objs: [response.data.license]
          });
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Settings updated successfully",
              "Impostazioni aggiornate correttamente"
            ),
            type: "confirm"
          });
        })
        .catch(error => console.log(error));
    }
  },
  created() {
    // Blocco l'accesso se ho un permesso di basso livello o se la licenza è una delle demo e il permesso non è superuser
    if(this.permission > 3 
        || (this.permission !== 1 && (this.license.work === 1 || this.license.work === 2 || this.license.work === 289))) {
      this.$router.push('/').catch(e => console.log(e));
      return;
    }
    // Aggiornamento dati in caso di modifiche di implementazione
    // PAYMENT METHODS
    [1,3,4,5,7,9,10]
      .forEach(pid => {
        const index = this.license.paymentMethods.findIndex(lpm => lpm.id === pid);
        if(index === -1) {
          this.license.paymentMethods.push({
            id: pid,
            obj: this.$anm22.tableClasses.worldPaymentModeType().getById(pid),
            admin: false,
            customer: false
          });
        } else {
          this.license.paymentMethods[index].obj = this.$anm22.tableClasses.worldPaymentModeType().getById(pid);
        }
        // payment surcharge legacy
        if(!this.license.paymentSurcharges[pid]) {
          this.license.paymentSurcharges[pid] = {
            fixed: 0,
            percent: 0
          };
        }
      });
    // DELIVERY TYPES
    [1,2,3,4,5,6,7,8,9,10]
      .forEach(did => {
        const index = this.license.deliveryTypes.findIndex(ldt => ldt.id === did);
        if(index === -1) {
          this.license.deliveryTypes.push({
            id: did,
            obj: this.$anm22.tableClasses.worldDeliveryType().getById(did),
            admin: false,
            customer: false
          });
        } else {
          this.license.deliveryTypes[index].obj = this.$anm22.tableClasses.worldDeliveryType().getById(did);
        }
        // delivery price legacy
        if(!this.license.deliveryPrices[did]) {
          this.license.deliveryPrices[did] = 0;
        }
      });
    // RECEIPT TYPES
    [1,2]
      .forEach(rid => {
        const index = this.license.customerReceiptTypes.findIndex(lrt => lrt.id === rid);
        if(index === -1) {
          this.license.customerReceiptTypes.push({
            id: rid,
            obj: this.$anm22.tableClasses.worldReceiptType().getById(rid),
            customer: false
          });
        } else {
          this.license.customerReceiptTypes[index].obj = this.$anm22.tableClasses.worldReceiptType().getById(rid);
        }
      });
    this.$Progress.start();
    //Da caricare: WorldDocumentSeries
    this.$http
      .get('settings/license')
      .then(response => {
        Promise.all([
          this.$store.dispatch('documentSeries/update', {
            vlf: this.$vlf('documentSeries'), objs: response.data.documentSeries
          }),
          this.$store.dispatch('ybLicenses/update', {
            vlf: this.$vlf('ybLicenses'), objs: response.data.ybLicenses
          }),
        ])
        .then(() => {
          this.$Progress.finish();
        });
      })
      .catch(error => console.log(error));
  },
}
</script>

<style lang="scss" scoped>
.checkbox-label {
  user-select: none;
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.radio-label {
  user-select: none;
  display: block;
  padding-left: 25px;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 50%;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}

.card {
  border-radius: 5px;
  border: 1px solid #ccc;
  transition: 0.2s;
  background-color: #fff;

  .title {
    border-radius: 5px;
    flex-wrap:nowrap;
    align-items:center;
    justify-content:space-between;
    cursor:pointer;
    user-select: none;
    padding: 10px;
    &:hover {
      background-color: #eee;
    }
  }
  .edit-button {
    font-size: 14px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    &:hover {
      background-color: #eee;
    }
  }
  .body {
    padding: 20px 10px 10px 10px;
    border-top: 1px solid #ccc;
  }
}
.pickup-point-label {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  padding: 5px;
  margin-right: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
</style>
